import { SectionHeader } from '@/components/shared/section-header'
import { BlokProps } from '@/lib/types'
import { FoundationalBlocksStoryblok } from '@/lib/types/component-types-sb'
import { DynamicIconName } from '@/lib/types/icon'
import { storyblokEditable } from '@storyblok/react/rsc'
import { DynamicIcon } from 'lucide-react/dynamic'
import Link from 'next/link'
import { JSX } from 'react'

export function FoundationalBlocks({ blok }: BlokProps<FoundationalBlocksStoryblok>) {
  return (
    <section
      className={'border-border border-y py-32'}
      {...storyblokEditable(blok)}
    >
      <div className="page-container space-y-16">
        <SectionHeader
          preTitle={blok.descriptorTitle}
          icon={blok.descriptorIcon}
          title={blok.title}
        />
        <div className={'border-border rounded-lg border'}>
          {blok.items?.map((group) => {
            return (
              <div
                {...storyblokEditable(group)}
                key={group._uid}
                className={'border-border grid grid-cols-1 border-b last:border-b-0 lg:grid-cols-2'}
              >
                <div className={'border-border border-b px-8 py-7 lg:border-e lg:border-b-0'}>
                  <h3 className={'text-accent-foreground text-2xl font-medium'}>{group.title}</h3>
                </div>
                <div className={'grid grid-cols-1 gap-2.5 p-2.5 lg:grid-cols-2'}>
                  {group.items?.map((item) => {
                    const hasLink =
                      item.link?.cached_url !== undefined && item.link?.cached_url !== ''

                    const Tag = hasLink ? Link : ('div' as keyof JSX.IntrinsicElements)

                    return (
                      // @ts-expect-error dynamic tag
                      <Tag
                        {...storyblokEditable(item)}
                        key={item._uid}
                        {...(hasLink
                          ? {
                              href: item.link?.cached_url,
                            }
                          : {})}
                        className={
                          'bg-sidebar border-border flex items-center gap-3 rounded-md border p-2.5'
                        }
                      >
                        {item.icon && (
                          <div className="bg-brand flex h-12 w-12 items-center justify-center rounded-md text-white">
                            <DynamicIcon name={item.icon as DynamicIconName} />
                          </div>
                        )}
                        <div>
                          <span className={'text-accent-foreground block text-xl font-semibold'}>
                            {item.title}
                          </span>
                          <span className={'block'}>{item.subTitle}</span>
                        </div>
                      </Tag>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
